import AdminLayout from "./AdminLayout";
import AdminAccounts from "./AdminAccounts";

export default function AdminAccountsPage() {
  return (
    <AdminLayout>
      <AdminAccounts />
    </AdminLayout>
  );
}
